import { Container } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

/** Width to pass as `rightSectionWidth` on the input hosting this section. */
export const VITALS_UNIT_RIGHT_SECTION_WIDTH = 89;

/** Grey unit chip pinned to the right of a vitals `NumberInput`, e.g. `bpm`, `kg` or `°C`. */
export function VitalsUnitRightSection({ unit }: { unit: string }) {
  return (
    <Container
      h="100%"
      bg="gray.1"
      display="flex"
      miw={VITALS_UNIT_RIGHT_SECTION_WIDTH}
      style={{
        borderLeft: "1px solid var(--mantine-color-gray-5)",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TextWrapper c="gray.7">{unit}</TextWrapper>
    </Container>
  );
}

export default VitalsUnitRightSection;
